import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { Delete, Fingerprint } from 'lucide-react';

import CustomText from '../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import useSecureStorage from '../../hooks/useSecureStorage';

import WebApp from '@twa-dev/sdk'
import { tgShowAlert } from '../../utils/telegramPopup';

interface PinCodeScreenProps {
	onSuccess: (decPin: string) => void;
	unlock: boolean;
}

const PIN_LENGTH = 6

const PinCodeScreen: React.FC<PinCodeScreenProps> = ({ onSuccess, unlock }) => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	const { t } = useTranslation();

	let dispatch = useDispatch();


	const { checkPincodeMatch, retrieveEncryptedData, getBlockChain } = useSecureStorage()
	const [pin, setPin] = useState<string[]>([])
	const [error, setError] = useState(false)
	const [showFingerprintAuth, setShowFingerprintAuth] = useState(false)
	const [fingerprintEnabled, setFingerprintEnabled] = useState(false)
	const [shuffledKeys, setShuffledKeys] = useState<string[]>([])
	const [showKeypad, setShowKeypad] = useState(false)

	useEffect(() => {
		setShuffledKeys(shuffleArray(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']))

		// 생체인증 초기화
		const initializeTgBio = async () => {
			console.log(`PinCodeScreen initializeTgBio`)
			console.log(`initializeTgBio WebApp.BiometricManager.isInited : ${WebApp.BiometricManager.isInited}`)
			
			// 생체인증 초기화 완료를 기다리는 로직 추가
			let retryCount = 0
			const maxRetries = 20 // 최대 4초간 대기 (200ms * 20)
			
			const waitForBioInit = async (): Promise<void> => {
				return new Promise((resolve) => {
					const checkInit = () => {
						if (WebApp.BiometricManager.isInited) {
							console.log(`생체인증 초기화 완료됨 (${retryCount + 1}회 시도)`)
							resolve()
						} else if (retryCount < maxRetries) {
							retryCount++
							console.log(`생체인증 초기화 대기 중... (${retryCount}/${maxRetries})`)
							setTimeout(checkInit, 200)
						} else {
							console.log(`생체인증 초기화 대기 시간 초과`)
							resolve()
						}
					}
					checkInit()
				})
			}

			// 생체인증 초기화 대기
			await waitForBioInit()
			
			if (true === WebApp.BiometricManager.isInited) {
				await TgWebAppStartBioAuth()
			} else {
				console.log(`텔레그램 생체인증 초기화 실패 상태`)
			}
		};

		const checkFingerprintSetting = async () => {
			try {
				const value = await localStorage.getItem('fingerprintEnabled')
				setFingerprintEnabled(value === 'true')
				setShowKeypad((value === 'true') ? false : true)
			} catch (error) {
				console.error('Failed to retrieve fingerprint setting from storage', error)
			}
		};

		initializeTgBio()
		checkFingerprintSetting()
	}, [])

	useEffect(() => {
		if (pin.length === PIN_LENGTH) {
			handleConfirm()
		}
	}, [pin])


	// 텔레그램 생체인증 시작
	const TgWebAppStartBioAuth = async () => {
		try {
			const useFingerprintEnabled = await localStorage.getItem('fingerprintEnabled')
			console.log(`1. PinCodeScreen TgWebAppStartBioAuth useFingerprintEnabled : ${useFingerprintEnabled}`)

			// 지문인증 사용설정, 지문인증 기능 사용 가능하고 접근권한 신청하지 않은 상태
			if ('true' === useFingerprintEnabled && true === WebApp.BiometricManager.isBiometricAvailable) {
				console.log(`2. PinCodeScreen TgWebAppStartBioAuth WebApp.BiometricManager.isBiometricAvailable TRUE`)
				if (false === WebApp.BiometricManager.isAccessGranted) {
					// 지문인식 접근권한이 없는 경우
					console.log(`3. PinCodeScreen TgWebAppStartBioAuth WebApp.BiometricManager.isAccessRequested FALSE`)

					console.log(`4. PinCodeScreen TgWebAppStartBioAuth WebApp.BiometricManager.requestAccess 권한 요청 시작`)
					const bioParam = { reason: "Telegram BiometricManager requestAccess" }
					WebApp.BiometricManager.requestAccess(bioParam, TgWebAppBioRequestAccessCallBack)
				} else if (true === WebApp.BiometricManager.isAccessGranted) {
					// 지문인식 접근권한이 있는 경우
					console.log(`5. PinCodeScreen TgWebAppStartBioAuth WebApp.BiometricManager.isAccessRequested TRUE`)
					const bioParam = { reason: "Telegram BiometricManager authenticate" }
					WebApp.BiometricManager.authenticate(bioParam, TgWebAppBioAuthenticateCallBack)
				}
			}
		} catch (error) {
			console.error(`Error Start BioAuth`, error)
		}
	}

	// 텔레그램 생체인식 권한요청 callback()
	const TgWebAppBioRequestAccessCallBack = async (isAccessGranted: boolean) => {
		try {
			console.log(`6. PinCodeScreen TgWebAppBioRequestAccessCallBack isAccessGranted : ${isAccessGranted}`)
			if(true === isAccessGranted) {
				// 생체인식 권한 요청 성공

				// 지문인증 사용 권한요청 성공했으므로 지문인증 과정 진행
				const bioParam = { reason: "Telegram BiometricManager authenticate" }
				WebApp.BiometricManager.authenticate(bioParam, TgWebAppBioAuthenticateCallBack)
			} else {
				// 생체인식 권한 요청 실패
				// await tgShowAlert(t('create_wallet_message_16'));
				await alert(t('create_wallet_message_16'));
				// navigate(`/CreateWallet`, { replace: true, state: { } });
			}
		} catch (error) {
			console.error("Error TgWebAppBioRequestAccessCallBack Req Bio Access", error)
		}
		return;
	};

	// 텔레그램 생체인식 인증요청 callback()
	const TgWebAppBioAuthenticateCallBack = async (isSuccess: boolean, bioToken: string) => {
		try {
			console.log(`TgWebAppBioAuthenticateCallBack() !!!!!`)
			console.log(`텔레그램 BiometricManager 인증요청 결과 : ${isSuccess}`)

			console.log(`UnlockScreen 텔레그램 SDK API 생체인식 상태`)
			console.log(`WebApp.BiometricManager.isBiometricAvailable : ${WebApp.BiometricManager.isBiometricAvailable}`)
			console.log(`WebApp.BiometricManager.biometricType : ${WebApp.BiometricManager.biometricType}`)
			console.log(`WebApp.BiometricManager.isAccessRequested : ${WebApp.BiometricManager.isAccessRequested}`)
			console.log(`WebApp.BiometricManager.isAccessGranted : ${WebApp.BiometricManager.isAccessGranted}`)
			console.log(`WebApp.BiometricManager.isBiometricTokenSaved : ${WebApp.BiometricManager.isBiometricTokenSaved}`)

			const selNetwork = await getBlockChain()

			if(true === isSuccess) {
				// 지문인식 진행
				// 핀코드 비교 확인
				let strPin = ''
				let pinMatch = false
				if (null !== bioToken && 6 <= bioToken.length) {
					strPin = bioToken.trim()
					pinMatch = await checkPincodeMatch(strPin, selNetwork)
				} else {
					pinMatch = false
				}

				if (true === pinMatch) {
					onSuccess(strPin)
				} else {
					setPin([])
				}
			} else {
				// 지문인식 취소
				// WebApp.showAlert(t('unlock_screen_message_02'))
				await alert(t('unlock_screen_message_02'));
				setShowKeypad(true)
			}
		} catch (error) {
			console.log(`Error Tg Bio Auth`, error)
		}
	}


	const handleKeyPress = (key: string) => {
		if (key === 'backspace') {
			setPin(prevPin => prevPin.slice(0, -1))
		} else {
			if (pin.length < PIN_LENGTH) {
				setPin(prevPin => [...prevPin, key])
			}
		}
	}

	const handleConfirm = async () => {
		try {
			const selNetwork = await getBlockChain()
			const strPin = pin.join('')
			const pinMatch = await checkPincodeMatch(strPin, selNetwork)

			if (true === pinMatch) {
				onSuccess(strPin)
			} else {
				setError(true)
				setTimeout(() => {
					setPin([])
					setError(false)
				}, 1000)
			}
		} catch (error) {
			console.error('Failed to retrieve the pin from storage', error)
		}
	}

	const handleFingerprint = async () => {
		try {
			// 생체인증 초기화 완료를 기다리는 로직 추가
			let retryCount = 0
			const maxRetries = 10 // 최대 2초간 대기 (200ms * 10)
			
			const waitForBioInit = async (): Promise<void> => {
				return new Promise((resolve) => {
					const checkInit = () => {
						if (WebApp.BiometricManager.isInited) {
							console.log(`handleFingerprint 생체인증 초기화 완료됨 (${retryCount + 1}회 시도)`)
							resolve()
						} else if (retryCount < maxRetries) {
							retryCount++
							console.log(`handleFingerprint 생체인증 초기화 대기 중... (${retryCount}/${maxRetries})`)
							setTimeout(checkInit, 200)
						} else {
							console.log(`handleFingerprint 생체인증 초기화 대기 시간 초과`)
							resolve()
						}
					}
					checkInit()
				})
			}

			// 생체인증 초기화 대기
			await waitForBioInit()
			
			if (true === WebApp.BiometricManager.isInited) {
				await TgWebAppStartBioAuth()
				
				// 키패드 숨김
				setShowKeypad(false)
			} else {
				console.warn(`생체인증 초기화가 완료되지 않음`)
			}
		} catch(error) {
			console.warn(`Error Tegeram BiometricManager`, error)
		}
	}

	const shuffleArray = (array: string[]) => {
		let currentIndex = array.length,
			randomIndex

		while (currentIndex !== 0) {
			randomIndex = Math.floor(Math.random() * currentIndex)
			currentIndex--
				;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
		}

		return array
	}

	const renderKey = (key: string, index: number) => (
		<div style={styles.keyWrapper} key={index}>
			<div
				onClick={() => { handleKeyPress(key) }}
				style={{
					// backgroundColor: theme.keyPadBackgroundColor,
					borderRadius: '50%',
				}}
			>
				<div className='pincodeBtn' style={styles.key}>
					<CustomText weight='medium' style={{ ...styles.keyText, color: theme.label_strong }}>
						{key}
					</CustomText>
				</div>
			</div>
		</div>
	)

	const styles = {
		container: {
			padding: "60px 5px 24px",
			position: "relative",
		} as React.CSSProperties,
		unlockContainer: {
			padding: "60px 5px 0px",
			position: "relative",
			minHeight: "calc(100vh - 70px)"
		} as React.CSSProperties,
		header: {
			height: "90px"
		} as React.CSSProperties,
		title1: {
			fontSize: 24,
			textAlign: 'center',
			color: theme.label_strong,
		} as React.CSSProperties,
		title2: {
			fontSize: 24,
			textAlign: 'center',
			color: theme.label_strong,
			marginBottom: 10
		} as React.CSSProperties,
		pinContainer: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			gap: '10px',
		} as React.CSSProperties,
		pinDot: {
			width: 12,
			height: 12,
			borderRadius: 8,
			margin: 8
		} as React.CSSProperties,
		pinDotError: {
			backgroundColor: theme.status_destrective,
		} as React.CSSProperties,
		basicText: {
			fontSize: 14,
			height: "40px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			marginTop: "15px",
			textAlign: 'center',
			lineHeight:"22px"
		} as React.CSSProperties,
		errorText: {
			fontSize: 14,
			height: "40px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			marginTop: "15px"
		} as React.CSSProperties,
		keypadContainer: {
			width: '100%',
		} as React.CSSProperties,
		keypadRow: {
			display: 'flex',
			justifyContent: 'space-around',
			width: '100%',
			marginBottom: 5,
		} as React.CSSProperties,
		keyWrapper: {
			cursor: "pointer"
		} as React.CSSProperties,
		key: {
			width: 70,
			height: 70,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			// margin: 10
		} as React.CSSProperties,
		keyPlaceholder: {
			width: 70,
			height: 70,
			// margin: 10
		} as React.CSSProperties,
		keyText: {
			fontSize: 24,
			textAlign: 'center'
		} as React.CSSProperties,
		fingerPrintIcon: {
			width: 10,
			height: 16,
		} as React.CSSProperties,
		imageContainer: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'flex-start',
			marginTop: '-120px',
		} as React.CSSProperties,
		image: {
            width: '180px',
            height: '180px',
        } as React.CSSProperties,	
	}

	return (
		<div className='container' style={{ ...(unlock ? styles.unlockContainer : styles.container), backgroundColor: theme.background_normal }}>
			{true === showKeypad && (
			<>
				<div style={styles.header}>
					<CustomText weight="medium" style={styles.title1}>
						{t('pincode_screen_message_05')}
					</CustomText>
					<CustomText weight="medium" style={styles.title2}>
						{t('pincode_screen_message_01')}
					</CustomText>
				</div>
				<div>
					<div style={styles.pinContainer}>
						{Array.from({ length: PIN_LENGTH }).map((_, index) => {
							const baseStyle: React.CSSProperties = {
								...styles.pinDot,
							};

							const activeStyle: React.CSSProperties =
								pin.length > index ? { backgroundColor: theme.primary_normal } : {};

							const errorStyle: React.CSSProperties =
								error && pin.length > index ? styles.pinDotError : {};

							return (
								<div style={{ borderBottom: `1px solid ${error?theme.status_destrective:pin.length > index?theme.primary_normal:theme.line_alternative}` }}>
									<div key={index} style={{ ...baseStyle, ...activeStyle, ...errorStyle }} />
								</div>
							);
						})}
					</div>
					{
						error
							?
							<CustomText style={{ ...styles.errorText, color: theme.status_destrective }}>
								{t('create_wallet_message_07')}
							</CustomText>
							:
							<CustomText style={{ ...styles.basicText, color: theme.label_normal }}>
								{t('create_wallet_message_14')}<br />
								{/* {t('create_wallet_message_15')} */}
							</CustomText>
					}
				</div>

				<div style={styles.keypadContainer}>
					{Array.from({ length: 3 }).map((_, rowIndex) => (
						<div key={rowIndex} style={styles.keypadRow}>
							{shuffledKeys.slice(rowIndex * 3, rowIndex * 3 + 3).map((key, index) => renderKey(key, index))}
						</div>
					))}

					{/* 마지막 줄: 빈 공간, 0, 백스페이스 */}
					{fingerprintEnabled ? (
						<>
							<div style={styles.keypadRow}>
								<div style={styles.keyWrapper} key="fingerprint" onClick={() => { handleFingerprint() }}>
									<div style={styles.key}>
										<Fingerprint size={24} color={theme.label_strong} />
									</div>
								</div>
								{renderKey(shuffledKeys[9], 9)}
								<div style={styles.keyWrapper} key="backspace" onClick={() => handleKeyPress('backspace')}>
									<div style={styles.key}>
										<Delete size={24} color={theme.label_strong} />
									</div>
								</div>
							</div>
						</>
					) : (
						<>
							<div style={styles.keypadRow}>
								<div style={styles.keyPlaceholder} />
								{renderKey(shuffledKeys[9], 9)}
								<div style={styles.keyWrapper} key="backspace" onClick={() => handleKeyPress('backspace')}>
									<div style={styles.key}>
										<Delete size={24} color={theme.label_strong} />
									</div>
								</div>
							</div>
						</>
					)}

				</div>
			</>
			)}

			{false === showKeypad && (
				<>
					<div style={styles.header}>
						<CustomText weight="medium" style={styles.title1}>
						{t('pincode_screen_message_05')}
						</CustomText>
						<CustomText weight="medium" style={styles.title2}>
							{t('pincode_screen_message_04')}
						</CustomText>
					</div>
					<div style={styles.imageContainer}>
						<img
							src={`./img/login_wallet_icon.png`} // process.env.PUBLIC_URL로 경로 설정
							alt=""
							style={{ ...styles.image, objectFit: 'contain' }} // objectFit으로 이미지 크기 조정
						/>
					</div>
					<div style={styles.keypadRow}>
						<div style={styles.keyWrapper} key="fingerprint" onClick={() => { handleFingerprint() }}>
							<div style={{ ...styles.key, position: 'relative', top: '-30px' }}>
								<Fingerprint size={24} color={theme.label_strong} />
							</div>
						</div>
					</div>
				</>
			)}

		</div>
	)
}

export default PinCodeScreen
